<div *ngIf="!_modal.success; else success" class="modal-body" align="center">
  <app-loading [padding]="320" *ngIf="loading"></app-loading>
  <div *ngIf="!loading">
    <h4 class="primary">
      <img src="assets/images/receipts/icn-success.png" alt="" />
      <b>Se ha cargado con éxito el comprobante.</b>
    </h4>
    <hr />
    <form [formGroup]="form" class="form-pages">
      <h4 class="text-left">
        Para continuar debes ingresar los siguientes datos
      </h4>
      <div class="row row-alert">
        <app-alert *ngIf="error" [alert]="error"></app-alert>
      </div>
      <div class="row">
        <div class="col-md-6">
          <div
            class="form-group has-feedback"
            [class.has-error]="helpers.invalidControl(form.get('issuingBank'))"
          >
            <label class="label-form" for="">Banco emisor</label>
            <select class="form-control" formControlName="issuingBank">
              <option value="" disabled selected>Selecciona el Banco</option>
              <option *ngFor="let bank of banks" value="{{ bank }}">
                {{ bank | titlecase }}
              </option>
            </select>
            <i
              class="glyphicon glyphicon-menu-down form-control-feedback custom-select-arrow"
            ></i>
            <span
              class="help-block invalid-feedback"
              *ngIf="helpers.invalidControl(form.get('issuingBank'))"
            >
              {{ constants.validations.required.message }}
            </span>
          </div>
        </div>
        <div class="col-md-6">
          <div
            class="form-group"
            [class.has-error]="
              helpers.invalidControl(form.get('issuingBankNumber'))
            "
          >
            <label class="label-form" for="">Nº de cuenta banco emisor</label>
            <input
              type="text"
              class="form-control"
              formControlName="issuingBankNumber"
              maxlength="20"
              mask="0*"
            />
            <span
              class="help-block invalid-feedback"
              *ngIf="helpers.invalidControl(form.get('issuingBankNumber'))"
            >
              <span *ngIf="form.get('issuingBankNumber').errors.required">{{
                constants.validations.required.message
              }}</span>
              <span *ngIf="form.get('issuingBankNumber').errors.pattern">{{
                constants.validations.numeric.message
              }}</span>
            </span>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6">
          <div
            class="form-group has-feedback"
            [class.has-error]="
              helpers.invalidControl(form.get('receivingBank'))
            "
          >
            <label class="label-form" for="">Banco receptor</label>
            <select class="form-control" formControlName="receivingBank">
              <option value="" disabled selected>Selecciona el Banco</option>
              <option *ngFor="let bank of banks" value="{{ bank }}">
                {{ bank | titlecase }}
              </option>
            </select>
            <i
              class="glyphicon glyphicon-menu-down form-control-feedback custom-select-arrow"
            ></i>
            <span
              class="help-block invalid-feedback"
              *ngIf="helpers.invalidControl(form.get('receivingBank'))"
              >{{ constants.validations.required.message }}
            </span>
          </div>
        </div>
        <div class="col-md-6">
          <div
            class="form-group has-feedback"
            [class.has-error]="!helpers.validDate(form.get('transferDate')) && form.get('transferDate').touched"
          >
            <label class="label-form" for="transferDate">Fecha de transferencia</label>
            <app-datepicker
              [control]="form.get('transferDate')"
              [controlName]="'transferDate'"
              [formRef]="form"
              [maxDate]="true"
            ></app-datepicker>
            <span
              class="help-block invalid-feedback"
              *ngIf="!helpers.validDate(form.get('transferDate')) && form.get('transferDate').touched"
            >
              {{ constants.validations.required.message }}
            </span>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6">
          <div
            class="form-group"
            [class.has-error]="helpers.invalidControl(form.get('amount'))"
          >
            <label class="label-form" for="">Monto</label>
            <input
              appAmount
              decimals="2"
              type="text"
              maxlength="11"
              class="form-control"
              formControlName="amount"
            />
            <span
                class="help-block invalid-feedback"
                *ngIf="helpers.invalidControl(form.get('amount'))"
              >
                <span *ngIf="form.get('amount').errors.required">{{
                  constants.validations.required.message
                }}</span>
                <span *ngIf="form.get('amount').errors.invalidAmount">{{
                  constants.validations.invalidAmount.message
                }}</span>
            </span>
          </div>
        </div>
        <div class="col-md-6">
          <div
            class="form-group has-feedback"
            [class.has-error]="helpers.invalidControl(form.get('currency'))"
          >
            <label class="label-form" for="">Moneda</label>
            <select class="form-control" formControlName="currency" (change)="monedaOnChange($event.target.value)">
              <option value="" disabled selected>Selecciona la moneda</option>
              <option
                *ngFor="let currency of currencies"
                value="{{ currency }}"
              >
                {{ currency }}
              </option>
            </select>
            <i
              class="glyphicon glyphicon-menu-down form-control-feedback custom-select-arrow"
            ></i>
            <span
              class="help-block invalid-feedback"
              *ngIf="helpers.invalidControl(form.get('currency'))"
            >
              <span *ngIf="form.get('currency').errors.required">{{
                constants.validations.required.message
              }}</span>
              <span *ngIf="form.get('currency').errors.invalidCurrency">{{
                constants.validations.invalidCurrency.message(_modal.request.currency)
              }}</span>
            </span>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div
            class="form-group has-feedback"
            [class.has-error]="
              helpers.invalidControl(form.get('operationNumber'))
            "
          >
            <label class="label-form" for="">Nº de operación</label>
            <input
              type="text"
              class="form-control"
              formControlName="operationNumber"
              maxlength="30"
              mask="0*"
            />
            <!-- <img
              src="assets/images/receipts/info.png"
              class="form-control-feedback info-icon"
              data-toggle="tooltip"
              data-placement="top"
              title="Esta información no está definida"
            /> -->
            <span
              class="help-block invalid-feedback"
              *ngIf="helpers.invalidControl(form.get('operationNumber'))"
            >
              {{ constants.validations.required.message }}
            </span>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div class="form-group">
            <label class="label-form" for="">Observación (opcional)</label>
            <textarea
              class="form-control"
              formControlName="observation"
              rows="3"
              maxlength="300"
            ></textarea>
          </div>
          <span class="text-right span-max-characters"
            >Máximo 300 caracteres *</span
          >
        </div>
      </div>
      <div class="row text-center">
        <button
          [disabled]="form.invalid || !helpers.validDate(form.get('transferDate')) || !banks"
          (click)="create()"
          class="button-continue button-find-label"
        >
          Guardar
        </button>
      </div>
    </form>
  </div>
</div>
<ng-template #success>
  <app-receipt-success
    (hidden)="init()"
    [operation]="'CREATE'"
    [receipt]="receipt"
  ></app-receipt-success>
</ng-template>
